import React from 'react';
import { motion } from 'framer-motion';

const BlogSkeleton = () => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                <div key={i} className="bg-white rounded-xl overflow-hidden shadow-sm p-4 h-[400px] flex flex-col">
                    <div className="w-full h-48 bg-gray-200 animate-pulse rounded-lg mb-4" />
                    <div className="h-6 bg-gray-200 animate-pulse rounded w-3/4 mb-4" />
                    <div className="flex-1 space-y-2">
                        <div className="h-4 bg-gray-200 animate-pulse rounded w-full" />
                        <div className="h-4 bg-gray-200 animate-pulse rounded w-5/6" />
                        <div className="h-4 bg-gray-200 animate-pulse rounded w-4/6" />
                    </div>
                    <div className="pt-4 border-t border-gray-100 flex justify-between">
                        <div className="h-4 bg-gray-200 animate-pulse rounded w-12" />
                        <div className="h-4 bg-gray-200 animate-pulse rounded w-12" />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default BlogSkeleton;
